import axios from 'axios';

const apiMercadoPago = axios.create({
  baseURL: process.env.REACT_APP_HOST_API_PAYMENT,
  headers: { Accept: 'application/json' },
});

export default apiMercadoPago;
